import { render } from "./Card1.vue?vue&type=template&id=04fcf51b"
import script from "./Card1.vue?vue&type=script&lang=ts"
export * from "./Card1.vue?vue&type=script&lang=ts"
script.render = render

export default script